import { render, staticRenderFns } from "./FichaDePartidoDetailView.vue?vue&type=template&id=52331874&scoped=true&"
import script from "./FichaDePartidoDetailView.vue?vue&type=script&lang=js&"
export * from "./FichaDePartidoDetailView.vue?vue&type=script&lang=js&"
import style0 from "./FichaDePartidoDetailView.vue?vue&type=style&index=0&id=52331874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52331874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContent,
  VFlex,
  VProgressCircular,
  VToolbar,
  VToolbarTitle,
})
